import { TabContext, TabList, Tab } from '@shared/components';

import {
  useAdminProctorRequestListSearchParams,
  type AdminProctorRequestStatus,
} from '../../hooks';

const TAB_ITEMS: { value: AdminProctorRequestStatus; label: string }[] = [
  {
    value: 'IN_REVIEW',
    label: 'คำขอที่รออนุมัติ',
  },
  {
    value: 'REJECTED',
    label: 'ไม่อนุมัติ',
  },
];

export default function AdminProctorRequestListNavigationTabs() {
  const [{ status }, { changeStatus }] = useAdminProctorRequestListSearchParams();
  const handleClick = (value: AdminProctorRequestStatus) => {
    changeStatus(value);
  };
  return (
    <TabContext value={status}>
      <TabList
        sx={(theme) => ({
          p: theme.spacing(4, 4, 0, 4),
        })}
      >
        {TAB_ITEMS.map((tab) => {
          return (
            <Tab
              key={tab.value}
              label={tab.label}
              value={tab.value}
              onClick={() => handleClick(tab.value)}
              sx={{
                minWidth: 'unset',
              }}
            />
          );
        })}
      </TabList>
    </TabContext>
  );
}
